/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneratedUserDto } from '../../models/generated-user-dto';

export interface GetGeneratedUsers$Params {
  'X-API-Version'?: string;
}

export function getGeneratedUsers(http: HttpClient, rootUrl: string, params?: GetGeneratedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneratedUserDto>>> {
  const rb = new RequestBuilder(rootUrl, getGeneratedUsers.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeneratedUserDto>>;
    })
  );
}

getGeneratedUsers.PATH = '/api/session/generated-users';
